// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-1aa384a8]{position:relative;left:4px}i[data-v-1aa384a8]:before{position:relative}i[data-v-1aa384a8]:first-child:before{top:3px}i[data-v-1aa384a8]:last-child:before{top:-3px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
